import jwt_decode from "jwt-decode";

const REDIRECT_KEY = "postLoginPath";

export const hasValidSession = () => {
  try {
    const session = jwt_decode(localStorage.getItem("token"));
    return [session.exp, session.sessionExpiresAt]
      .filter(Number.isFinite)
      .every((deadline) => Date.now() < deadline * 1000);
  } catch (error) {
    return false;
  }
};

export const rememberLoginPath = ({ pathname, search = "", hash = "" }) => {
  const params = new URLSearchParams(search);
  params.delete("token");
  params.delete("loginUrl");
  const query = params.toString();
  sessionStorage.setItem(
    REDIRECT_KEY,
    pathname + (query ? `?${query}` : "") + hash
  );
};

export const getLoginPath = () => {
  const path = sessionStorage.getItem(REDIRECT_KEY);
  if (!path) return "/admin";
  try {
    const url = new URL(path, window.location.origin);
    return url.origin === window.location.origin &&
      /^\/admin(?:\/|$)/.test(url.pathname)
      ? url.pathname + url.search + url.hash
      : "/admin";
  } catch (error) {
    return "/admin";
  }
};

export const clearLoginPath = () => sessionStorage.removeItem(REDIRECT_KEY);
